import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Modal from "react-modal";
import Layouts from "../../layouts/layouts";
import Select from "react-select";
import { Autocomplete, LoadScript } from "@react-google-maps/api";

Modal.setAppElement("#root");

export default function Create_charginglocation() {
  const title = "Add Charging Locations";
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [autocomplete, setAutocomplete] = useState(null);

  const [formData, setFormData] = useState({
    vehicle_id: "",
    charging_locations: [],
  });

  const [errors, setErrors] = useState({});
  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };
  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setVehicles(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };
    fetchVehicles();
  }, []);
  const handleVehicleChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      vehicle_id: selectedOption ? selectedOption.value : "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.vehicle_id) {
      newErrors.vehicle_id = "Vehicle Id  is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    if (name === "latitude" || name === "longitude") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        charging_locations: {
          ...prevFormData.charging_locations,
          [name]: value,
        },
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      if (lat && lng) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          charging_locations: [
            ...prevFormData.charging_locations,
            {
              latitude: lat,
              longitude: lng,
            },
          ],
        }));
      }
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };

  const removeCoordinate = (indexToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      charging_locations: prevFormData.charging_locations.filter(
        (_, i) => i !== indexToRemove
      ),
    }));
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const payload = {
      vehicle_id: formData.vehicle_id,
      charging_locations: formData.charging_locations,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v4/charging-data`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        navigate("/charginglocation");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error);
    }
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="vehicle_id">
                  <b>Vehicle *</b>
                </label>
                <Select
                  name="vehicle_id"
                  options={vehicles.map((vehicle) => ({
                    value: vehicle._id,
                    label: `${vehicle.numberplate}`,
                  }))}
                  onChange={(selectedOption) =>
                    handleVehicleChange(selectedOption)
                  }
                  classNamePrefix="select"
                />
                {errors.vehicle_id && (
                  <p className="text-danger">{errors.vehicle_id}</p>
                )}
              </div>
              <div className="col-md-6 mt-3"></div>

              <div className="col-md-6 mt-3">
                <label
                  htmlFor="charging_locations"
                  className="form-label fw-bold"
                >
                  📍 Select Location *
                </label>

                <div className="input-group shadow-sm mb-4">
                  <span className="input-group-text bg-light">
                    <i className="bi bi-geo-alt-fill text-primary"></i>
                  </span>
                  <LoadScript
                    googleMapsApiKey={process.env.REACT_APP_BASE_API}
                    libraries={["places"]}
                  >
                    <Autocomplete
                      onLoad={onLoad}
                      onPlaceChanged={onPlaceChanged}
                    >
                      <input
                        type="text"
                        placeholder="Search places..."
                        className="form-control"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault(); // prevent form submission
                          }
                        }}
                      />
                    </Autocomplete>
                  </LoadScript>
                </div>

                {formData.charging_locations.length > 0 ? (
                  <>
                    <h6 className="text-muted mt-3 mb-2">
                      📌 Coordinate Details
                    </h6>
                    <ul className="list-group shadow-sm">
                      {formData.charging_locations.map((coord, index) => (
                        <li
                          key={index}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <strong>Coordinate {index + 1}</strong> —{" "}
                            <span className="text-muted">
                              {coord.latitude.toFixed(4)},{" "}
                              {coord.longitude.toFixed(4)}
                            </span>
                          </div>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => removeCoordinate(index)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <p className="text-muted">No charging locations added yet.</p>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label className="form-label fw-bold">
                  📌 Added Coordinates *
                </label>

                {formData.charging_locations.length > 0 ? (
                  <div className="row g-3 mt-1">
                    {formData.charging_locations.map((coord, index) => (
                      <div key={index} className="col-12">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body d-flex justify-content-between align-items-center">
                            <div>
                              <span className="badge bg-secondary me-2">
                                {index + 1}
                              </span>
                              {coord.latitude.toFixed(4)},{" "}
                              {coord.longitude.toFixed(4)}
                            </div>
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => removeCoordinate(index)}
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No coordinates added yet.</p>
                )}
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Charging Location
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
